import { isBefore } from '@e3dc-react/shell/Libs/date'
import useSystemChartMinFromDate from './use-system-chart-min-from-date'
import useCostSavingsChartMinFromDate from './use-cost-savings-chart-min-from-date'

/**
 * This hooks provides the earliest date possible to show data for
 * - synced: it considers the earliest date of the system chart and the cost savings chart and takes the earliest one
 */
export const useSyncedMinFromDateForSystemAndCostSavingChart = (): string | undefined => {
  const systemChartMinFromDate = useSystemChartMinFromDate()
  const costSavingsChartMinFromDate = useCostSavingsChartMinFromDate()

  let syncedMinFrom = systemChartMinFromDate || costSavingsChartMinFromDate

  if (systemChartMinFromDate && costSavingsChartMinFromDate) {
    syncedMinFrom = isBefore(new Date(systemChartMinFromDate), new Date(costSavingsChartMinFromDate))
      ? systemChartMinFromDate
      : costSavingsChartMinFromDate
  }

  return syncedMinFrom
}
